import { render } from "./PhoneView.vue?vue&type=template&id=9a3a5cd2&scoped=true"
import script from "./PhoneView.vue?vue&type=script&lang=js"
export * from "./PhoneView.vue?vue&type=script&lang=js"

import "./PhoneView.vue?vue&type=style&index=0&id=9a3a5cd2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3a5cd2"]])

export default __exports__